import { Occasion } from '@moonpig/web-explore-types-graphql'
import { theme } from '@moonpig/launchpad-theme'
import reminderBannerDefaultMobile from './assets/moonpig/reminder-banner-default-mobile.svg'
import reminderBannerDefaultDesktop from './assets/moonpig/reminder-banner-default-desktop.svg'
import reminderBannerBirthdayMobile from './assets/moonpig/reminder-banner-birthday-mobile.svg'
import reminderBannerBirthdayDesktop from './assets/moonpig/reminder-banner-birthday-desktop.svg'
import reminderBannerMothersDayMobile from './assets/moonpig/reminder-banner-mothers-day-mobile.svg'
import reminderBannerMothersDayDesktop from './assets/moonpig/reminder-banner-mothers-day-desktop.svg'

export const ReminderBannerImage = (occasion: Occasion, isMobile: boolean) => {
  switch (occasion) {
    case Occasion.BIRTHDAY:
      return isMobile
        ? reminderBannerBirthdayMobile
        : reminderBannerBirthdayDesktop
    case Occasion.MOTHERS_DAY:
      return isMobile
        ? reminderBannerMothersDayMobile
        : reminderBannerMothersDayDesktop
    default:
      return isMobile
        ? reminderBannerDefaultMobile
        : reminderBannerDefaultDesktop
  }
}

export const ReminderBannerImageBackgroundColor = `${theme.colors.colorPrimary03}60`

const base = theme.colors.colorBackgroundInformation

export const ReminderBannerBackground = `
  linear-gradient(
    180deg,
    ${base} 0%,
    ${base}80 100%
  )
`

export const OCCASION_MAP: Record<string, { label: string; facetKey: string }> =
  {
    BIRTHDAY: { label: 'Birthday', facetKey: 'occasion-birthday' },
    ANNIVERSARY: { label: 'Anniversary', facetKey: 'anniversaries' },
    CHRISTMAS: { label: 'Christmas', facetKey: 'occasion-christmas' },
    FATHERS_DAY: { label: "Father's Day", facetKey: 'fathers-day' },
    MOTHERS_DAY: { label: "Mother's Day", facetKey: 'mothers-day' },
    VALENTINES_DAY: { label: "Valentine's Day", facetKey: 'valentines-day' },
    NEW_BABY: { label: 'New Baby', facetKey: 'occasion-new-baby' },
    WEDDING: { label: 'Wedding', facetKey: 'occasion-wedding' },
  }
